import React from "react";
import {AuthContext} from "../../context/AuthProvider";

// This app's own sign-in control, sitting in the top bar's user slot. It used to be a
// button on each app page (the former components/LoginStatus, rendered by components/Layout).
//
// Not to be confused with ./UserControls - that one reflects the shared Aspose account
// cookie the upstream menu service looked at, this one is our Keycloak session.

// signinRedirect/signoutRedirect reject asynchronously - without this the click just
// looks dead. Anything that goes wrong ends up in the console instead.
const run = (what, fn) => {
    try {
        const result = fn();
        if (result && typeof result.then === "function") {
            result.catch(err => console.error(`[AppLogin] ${what} failed`, err));
        }
    } catch (err) {
        console.error(`[AppLogin] ${what} failed`, err);
    }
};

const AppLogin = () => {
    // Tolerate a missing provider (wrap-root-element.js commented out) rather than crash
    // the whole bar over it - but say so, instead of rendering a button that does nothing.
    const auth = React.useContext(AuthContext);
    const {user, login, logout} = auth || {};
    const [open, setOpen] = React.useState(false);
    const box = React.useRef(null);

    React.useEffect(() => {
        if (!auth) console.error("[AppLogin] no AuthContext - is wrapRootElement wired up?");
    }, [auth]);

    // The upstream bar opens its dropdowns on hover, which never fires on a touch screen,
    // so the menu also answers to a click and closes when the focus moves away.
    React.useEffect(() => {
        if (!open) return undefined;
        const closeIfOutside = (e) => {
            if (box.current && !box.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("click", closeIfOutside);
        return () => document.removeEventListener("click", closeIfOutside);
    }, [open]);

    const name = user && (user.profile.name || user.profile.preferred_username);

    const anchorClick = (e) => {
        e.preventDefault();
        if (user) setOpen(!open);
        else if (login) run("log in", login);
    };

    return (
        <div className={open ? "userloginbox appuserbox open" : "userloginbox appuserbox"} ref={box}>
            <ul className={user ? "loginanchor loggeduser" : "loginanchor"}>
                <li>
                    <a href="#"
                       className="userlogin"
                       aria-expanded={user ? open : undefined}
                       onClick={anchorClick}>
                        <i className="fa fa-user"/>
                        <span className="userlabel">{user ? name : "LOG IN"}</span>
                    </a>
                    {user &&
                        <ul>
                            <li>
                                <a className="topurlink toplogout moblink"
                                   href="#"
                                   onClick={(e) => {
                                       e.preventDefault();
                                       setOpen(false);
                                       run("log out", logout);
                                   }}>
                                    LOG OUT
                                </a>
                            </li>
                        </ul>
                    }
                </li>
            </ul>
        </div>
    );
};

export default AppLogin;
